const Blogs = () => {
  const blogPosts = [
    {
      title: "Application Lifecycle & Request Response LifeCycle of Nest js",
      url: "https://medium.com/@rohitkc8848/application-lifecycle-request-response-lifecycle-of-nest-js-23cf9927fbd3",
      description:
        "An in-depth look at the application lifecycle in NestJS and how requests and responses are handled.",
    },
    {
      title: "How I Scaled Web-Socket-Server ???",
      url: "https://medium.com/@rohitkc8848/how-i-scaled-web-socket-server-fa8faa8f89ad",
      description:
        "Learn about the strategies I used to scale a WebSocket server for better performance.",
    },
    {
      title: "SOLID Design Principles Using TypeScript",
      url: "https://medium.com/@rohitkc8848/solid-design-principles-using-typesci-d2cd9c14089a",
      description:
        "Explore the SOLID design principles and how to implement them using TypeScript.",
    },
    {
      title: "Learn All about Dependency Injection in Nest js",
      url: "https://medium.com/@rohitkc8848/learn-how-dependency-injection-works-a254b9d46db4",
      description:
        "A comprehensive guide to understanding dependency injection and its benefits.",
    },
  ];

  return (
    <section
      id="blogs"
      className="relative py-20 bg-[#0a0a0f] border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-aos="fade-up" className="mb-12">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-light text-white mb-3">
            Blogs
          </h2>
          <p className="text-gray-400 text-lg">Sharing knowledge and insights</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {blogPosts.map((post, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              className="group relative bg-white/5 border border-white/10 rounded-lg p-6 md:p-8 hover:border-white/20 hover:bg-white/10 transition-all duration-300"
            >
              <div className="relative z-10">
                <h3 className="text-white text-xl md:text-2xl font-medium mb-3 group-hover:text-blue-400 transition-colors duration-300">
                  {post.title}
                </h3>
                <p className="text-gray-400 mb-6 leading-relaxed text-sm md:text-base">
                  {post.description}
                </p>
                <a
                  href={post.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors duration-300"
                >
                  Read More
                  <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blogs;
